import React, { useEffect, useState } from 'react'
import Layout from '../../../dashboard/components/Layout'
import Card from '../../../../components/Card'
import DataGrid from 'react-data-grid'
import { ArrowUp, EmployeeImage, Reqimage } from '../../../../assets/images'
import { Search } from '../../../../components'
import { useNavigate } from 'react-router-dom'
import CustomPagination from '../../../../components/Pagination'
import { Announcements, PersonalTimeOff, Stats } from '../../types'
import {
    announcementList,
    assignedTimeOff,
    dashboardstats,
    markAnnouncement,
    personalTimeOff,
} from '../../api'
import { useAppDispatch, useAppSelector } from '../../../../redux/hook'
import { HIDE_LOADER, SHOW_LOADER } from '../../../../redux/slices/LoaderSlice'
import { annDateFormat, formatDate } from '../../utils'
import { SHOW_NOTIFICATION } from '../../../../redux/slices/showNotificationSlice'
import { Icon } from '@iconify/react'
import { truncateString } from '../../../../utils'

const DirectorDashboard: React.FC = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const { id } = useAppSelector((state) => state.persistedReducers.user)
    const { show } = useAppSelector((state) => state?.loader)
    const [combinedtimeOff, setCombinedTimeOff] = useState<{
        personal: PersonalTimeOff[]
        assigned: PersonalTimeOff[]
    }>({
        personal: [],
        assigned: [],
    })

    const [combinedtotalCount, setCombinedtotalCount] = useState<{
        personal: number
        assigned: number
    }>({
        personal: 0,
        assigned: 0,
    })
    const [combinedcurrentPage, setCombinedCurrentpage] = useState<{
        personal: number
        assigned: number
    }>({
        personal: 1,
        assigned: 1,
    })
    const assignedtotalPages = Math.ceil(combinedtotalCount.assigned / 3)
    const totalPages = Math.ceil(combinedtotalCount.personal / 3)
    const [stats, setuserStats] = useState<Stats>({
        userCount: 0,
        timeOffCount: 0,
    })
    const [announcementsList, setAnnouncemnetsList] = useState<Announcements[]>(
        []
    )
    const [search, setSearch] = useState<string>('')

    useEffect(() => {
        dispatch(SHOW_LOADER())
        const getUserstats = async () => {
            try {
                const response = await dashboardstats()
                setuserStats({
                    timeOffCount: response.data.timeOffCount,
                    userCount: response.data.userCount,
                })
                dispatch(HIDE_LOADER())
            } catch (err) {
                // Handle any errors here
                console.error('Error fetching:', err)
                dispatch(HIDE_LOADER())
            }
        }

        getUserstats()
    }, [])

    useEffect(() => {
        const gettimeOff = async () => {
            try {
                const response = await personalTimeOff(
                    3,
                    combinedcurrentPage.personal,
                    id
                )
                setCombinedTimeOff((prevState) => ({
                    ...prevState,
                    personal: response?.data?.data,
                }))
                setCombinedtotalCount((prevState) => ({
                    ...prevState,
                    personal: response?.data?.totalCount,
                }))
                dispatch(HIDE_LOADER())
            } catch (err) {
                // Handle any errors here
                console.error('Error fetching:', err)
                dispatch(HIDE_LOADER())
            }
        }

        gettimeOff()
    }, [combinedcurrentPage.personal])

    useEffect(() => {
        const getassignedtimeOff = async () => {
            try {
                const response = await assignedTimeOff(
                    3,
                    combinedcurrentPage.assigned
                )
                setCombinedTimeOff((prevState) => ({
                    ...prevState,
                    assigned: response?.data?.data,
                }))
                setCombinedtotalCount((prevState) => ({
                    ...prevState,
                    assigned: response?.data?.totalCount,
                }))
                dispatch(HIDE_LOADER())
            } catch (err) {
                // Handle any errors here
                console.error('Error fetching:', err)
                dispatch(HIDE_LOADER())
            }
        }

        getassignedtimeOff()
    }, [combinedcurrentPage.assigned])

    const getannouncements = async () => {
        try {
            const response = await announcementList(100, 1, search)
            if (response?.data?.data?.length !== 0) {
                response.data.data.sort((a: any, b: any) => {
                    return (
                        new Date(b.lastModifiedOn).getTime() -
                        new Date(a.lastModifiedOn).getTime()
                    )
                })
            }
            setAnnouncemnetsList(response?.data?.data)
            dispatch(HIDE_LOADER())
        } catch (err) {
            // Handle any errors here
            console.error('Error fetching:', err)
            dispatch(HIDE_LOADER())
        }
    }

    useEffect(() => {
        getannouncements()
    }, [search])

    const getValue = (value: string) => {
        setSearch(value)
    }

    const completeMark = async (id: string) => {
        dispatch(SHOW_LOADER())
        try {
            const response = await markAnnouncement(id)
            if (response.status === 200) {
                dispatch(HIDE_LOADER())
                getannouncements()
                dispatch(
                    SHOW_NOTIFICATION({
                        type: 'success',
                        message: 'Read successfully',
                    })
                )
            }
        } catch (err) {
            dispatch(HIDE_LOADER())
            console.log('Error fetching', err)
        }
    }

    const column = [
        {
            key: 'leaveType',
            name: `Type`,
            resizable: true,
            sortable: true,
        },
        {
            key: 'status',
            name: `Status`,
            resizable: true,
            sortable: true,
            renderCell: (props: any) => {
                return (
                    <div
                        className={
                            props.row.status === 'Pending'
                                ? 'status'
                                : props.row.status === 'Rejected'
                                  ? 'rej'
                                  : 'appr'
                        }
                    >
                        {props.row.status}
                    </div>
                )
            },
        },
        {
            key: 'date',
            name: `Date`,
            resizable: true,
            sortable: true,
            renderCell: (props: any) => {
                return (
                    <div className="">
                        {formatDate(props.row.startDate)} -{' '}
                        {formatDate(props.row.endDate)}
                    </div>
                )
            },
        },
    ]

    const column1 = [
        {
            key: 'name',
            name: `Name`,
            resizable: true,
            sortable: true,
        },
        {
            key: 'leaveType',
            name: `Type`,
            resizable: true,
            sortable: true,
        },
        {
            key: 'status',
            name: `Status`,
            resizable: true,
            sortable: true,
            renderCell: (props: any) => {
                return (
                    <div
                        className={
                            props.row.status === 'Pending'
                                ? 'status'
                                : props.row.status === 'Rejected'
                                  ? 'rej'
                                  : 'appr'
                        }
                    >
                        {props.row.status}
                    </div>
                )
            },
        },
        {
            key: 'date',
            name: `Dates`,
            resizable: true,
            sortable: true,
            renderCell: (props: any) => {
                return (
                    <div className="">
                        {formatDate(props.row.startDate)} -{' '}
                        {formatDate(props.row.endDate)}
                    </div>
                )
            },
        },
    ]

    const getCurrentPage = (page: number, peronsnal: boolean) => {
        peronsnal
            ? setCombinedCurrentpage((prevState) => ({
                  ...prevState,
                  personal: page,
              }))
            : setCombinedCurrentpage((prevState) => ({
                  ...prevState,
                  assigned: page,
              }))
    }

    return (
        <div>
            <Layout>
                <div className="row">
                    <div className="col-sm-8">
                        <div className="row">
                            <div className="col-md-6">
                                <Card>
                                    <div className="dashboard-card">
                                        <div className="row d-flex align-items-center">
                                            <h6 className="col-8">
                                                Total Employees
                                            </h6>
                                            <div className="col-4">
                                                <div className="ms-auto background">
                                                    <img src={EmployeeImage} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mt-5 stats d-flex align-items-center">
                                            <span className="col-6">
                                                <h6>{stats?.userCount}</h6>
                                            </span>
                                            <span className="col-6 text-end">
                                                <p
                                                    className="viewstats"
                                                    onClick={() =>
                                                        navigate('/employees')
                                                    }
                                                >
                                                    View <img src={ArrowUp} />
                                                </p>{' '}
                                            </span>
                                        </div>
                                    </div>
                                </Card>
                            </div>

                            <div className="col-md-6">
                                <Card>
                                    <div>
                                        <div className="row d-flex align-items-center">
                                            <h6 className="col-8">
                                                Total Time-Off Requests
                                            </h6>
                                            <div className="col-4">
                                                <div className="ms-auto background">
                                                    <img src={Reqimage} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mt-5 stats d-flex align-items-center">
                                            <span className="col-6">
                                                <h6>{stats?.timeOffCount}</h6>
                                            </span>
                                            <span className="col-6 text-end">
                                                <p
                                                    className="viewstats"
                                                    onClick={() =>
                                                        navigate('/timeoffreq')
                                                    }
                                                >
                                                    View <img src={ArrowUp} />
                                                </p>{' '}
                                            </span>
                                        </div>
                                    </div>
                                </Card>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <Card>
                                    <div>
                                        <h6>Personal Upcoming Time Off</h6>
                                    </div>

                                    {!show &&
                                    combinedtimeOff.personal &&
                                    combinedtimeOff.personal?.length > 0 ? (
                                        <DataGrid
                                            className="data-grid-table custom"
                                            columns={column}
                                            rows={combinedtimeOff.personal}
                                            rowHeight={60}
                                            headerRowHeight={40}
                                        />
                                    ) : (
                                        <>
                                            <div className="no-records">
                                                You don’t have any upcoming Paid
                                                Time Off.
                                            </div>
                                        </>
                                    )}

                                    {combinedtimeOff.personal?.length > 0 && (
                                        <CustomPagination
                                            totalPages={totalPages}
                                            currentPage={
                                                combinedcurrentPage.personal
                                            }
                                            getPageNumber={(page: number) =>
                                                getCurrentPage(page, true)
                                            }
                                        />
                                    )}
                                </Card>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12">
                                <Card>
                                    <div>
                                        <h6>Time-Off Requests</h6>
                                    </div>
                                    {!show &&
                                    combinedtimeOff?.assigned &&
                                    combinedtimeOff?.assigned?.length > 0 ? (
                                        <DataGrid
                                            className="data-grid-table custom"
                                            columns={column1}
                                            rows={combinedtimeOff.assigned}
                                            rowHeight={60}
                                            headerRowHeight={40}
                                        />
                                    ) : (
                                        <>
                                            <div className="no-records">
                                                There are no upcoming Time-Off
                                                Requests.
                                            </div>
                                        </>
                                    )}

                                    {combinedtimeOff?.assigned?.length > 0 && (
                                        <CustomPagination
                                            totalPages={assignedtotalPages}
                                            currentPage={
                                                combinedcurrentPage.assigned
                                            }
                                            getPageNumber={(page: number) =>
                                                getCurrentPage(page, false)
                                            }
                                        />
                                    )}
                                </Card>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-4 dashboard-announcements">
                        <Card>
                            <div className="announcement-block">
                                <h6>Announcements</h6>
                            </div>
                            <div>
                                <Search
                                    placeholder="Search Announcement"
                                    onSearch={getValue}
                                />
                            </div>

                            {announcementsList.length === 0 ? (
                                <div className="no-announcements">
                                    No Announcements yet.
                                </div>
                            ) : (
                                announcementsList.map(
                                    (announcements: Announcements) => {
                                        return (
                                            <div
                                                className="announcemt-section"
                                                key={`ann-${announcements.id}`}
                                            >
                                                <label>
                                                    {
                                                        announcements.announcementTitle
                                                    }
                                                </label>

                                                <p className="mt-1">
                                                    {
                                                        announcements.announcementDescription
                                                    }
                                                </p>
                                                {announcements.link && (
                                                    <div className="mb-1">
                                                        <span>
                                                            {truncateString(
                                                                announcements.link
                                                            )}
                                                        </span>
                                                        <Icon
                                                            icon="ion:open-outline"
                                                            color="#39877C"
                                                            style={{
                                                                cursor: 'pointer',
                                                                marginLeft:
                                                                    '5px',
                                                            }}
                                                            onClick={() => {
                                                                const url =
                                                                    announcements.link.startsWith(
                                                                        'http://'
                                                                    ) ||
                                                                    announcements.link.startsWith(
                                                                        'https://'
                                                                    )
                                                                        ? announcements.link
                                                                        : `http://${announcements.link}`
                                                                window.open(
                                                                    url,
                                                                    '_blank'
                                                                )
                                                            }}
                                                        />
                                                    </div>
                                                )}
                                                <div className="title">
                                                    <h5>
                                                        {annDateFormat(
                                                            announcements.lastModifiedOn
                                                        )}
                                                    </h5>
                                                    <h6
                                                        onClick={() =>
                                                            completeMark(
                                                                announcements.id
                                                            )
                                                        }
                                                    >
                                                        {'Mark as read'}
                                                    </h6>
                                                </div>
                                            </div>
                                        )
                                    }
                                )
                            )}
                        </Card>
                    </div>
                </div>
            </Layout>
        </div>
    )
}

export default DirectorDashboard
